// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__35cPk","errorLogs":"styles_errorLogs__2IKJn"};